class AddressAutocomplete {
  constructor(input, componentForm) {
    if (!input || !componentForm) {
      console.error('AddressAutocomplete: Missing required parameters');
      return;
    }

    this.input = input instanceof jQuery ? input[0] : input;
    this.componentForm = componentForm;
    this.initialize();
  }

  async initialize() {
    try {
      const { AutocompleteService } = await google.maps.importLibrary("places");
      this.autocompleteService = new AutocompleteService();
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
      this.initializeAutocomplete();
    } catch (error) {
      console.error('Error initializing Places API:', error);
    }
  }

  initializeAutocomplete() {
    try {
      if (!this.input?.getAttribute) {
        console.error('Invalid input element:', this.input);
        return;
      }

      const options = {
        fields: ['formatted_address', 'address_components', 'geometry', 'name'],
        regionCode: 'US',
        language: 'en',
        strictBounds: false,
        types: []
      };

      // Setup input event listener
      this.input.addEventListener('input', this.handleInput.bind(this));

      console.log('Places API initialized');
    } catch (error) {
      console.error('Error initializing Places API:', error);
    }
  }

  async handleInput(event) {
    try {
      const query = event.target.value;

      if (query.length < 3) return;

      const baseRequest = {
        input: query,
        sessionToken: this.sessionToken,
        componentRestrictions: { country: ['us', 'ca'] }
      };

      const establishmentRequest = {
        ...baseRequest,
        types: ['establishment']
      };

      const addressRequest = {
        ...baseRequest,
        types: ['address']
      };

      try {
        // First try establishment type
        const establishmentPredictions = await this.autocompleteService.getPlacePredictions(establishmentRequest);
        if (establishmentPredictions.predictions.length > 0) {
          this.displaySuggestions(establishmentPredictions.predictions);
          return;
        }

        // If no establishment results, try address type
        const addressPredictions = await this.autocompleteService.getPlacePredictions(addressRequest);
        this.displaySuggestions(addressPredictions.predictions);
      } catch (error) {
        console.error('Error getting predictions:', error);
      }
    } catch (error) {
      console.error('Error in handleInput:', error);
    }
  }

  displaySuggestions(predictions) {
    this.removeSuggestionsDropdown();

    const dropdown = document.createElement('ul');
    dropdown.className = 'places-suggestions';
    dropdown.style.cssText = `
      position: absolute;
      z-index: 1000;
      background: white;
      list-style: none;
      padding: 0;
      margin: 0;
      border: 1px solid #ccc;
      width: ${this.input.offsetWidth}px;
    `;

    predictions.forEach(prediction => {
      const li = document.createElement('li');
      li.style.cssText = 'padding: 8px; cursor: pointer; border-bottom: 1px solid #eee;';
      li.textContent = prediction.description;
      li.addEventListener('click', () => this.handleSuggestionClick(prediction));
      dropdown.appendChild(li);
    });

    this.input.parentNode.style.position = 'relative';
    this.input.parentNode.appendChild(dropdown);
  }

  async handleSuggestionClick(prediction) {
    try {
      const placesService = new google.maps.places.PlacesService(document.createElement('div'));
      const place = await new Promise((resolve, reject) => {
        placesService.getDetails({
          placeId: prediction.place_id,
          fields: ['address_components', 'formatted_address', 'geometry']
        }, (place, status) => {
          if (status === 'OK') resolve(place);
          else reject(new Error(status));
        });
      });

      this.fillInAddress(place);
      this.removeSuggestionsDropdown();
      this.input.value = prediction.description;
    } catch (error) {
      console.error('Error getting place details:', error);
    }
  }

  removeSuggestionsDropdown() {
    const existing = this.input.parentNode.querySelector('.places-suggestions');
    if (existing) existing.remove();
  }

  fillInAddress(place) {
    Object.values(this.componentForm).forEach(field => {
      $(field).val('');
    });

    place.address_components.forEach(component => {
      const addressType = component.types[0];
      if (this.componentForm[addressType]) {
        const val = component.long_name;
        const field = $(this.componentForm[addressType]);

        if (field.val()) {
          field.val(field.val() + ' ' + val);
        } else {
          field.val(val);
        }
      }
    });

    // Trigger change event on all fields to activate any listeners
    Object.values(this.componentForm).forEach(field => {
      $(field).trigger('change');
    });

    // Call the callback if it exists
    if (typeof this.onAddressSelected === 'function') {
      this.onAddressSelected();
    }
  }
}

export default AddressAutocomplete;
